module.exports = __webpack_public_path__ + "img/copy.de2684d.svg";